import React from 'react'
import {RangePoint} from 'yougile-model'
import {BooleanHookState} from '@containers/hooks'
import {PickerSection} from './picker-section'

export interface DateRange {
  start?: Date
  end?: Date
}

interface Props<T> {
  value: T
  onChange: (date: T) => void
  onDateValidate?: (isValid: boolean) => void
  showTimeInput?: boolean
  disablePastDates?: boolean
  valid?: BooleanHookState
}

export type DatePickerProps = Props<Date | undefined>

export const DatePicker = (props: DatePickerProps) => {
  const {value, onChange, showTimeInput, disablePastDates, valid} = props
  return (
    <div className={wrapperClassName}>
      <PickerSection
        dateRange={{start: value}}
        rangePoint={'start'}
        onChange={range => onChange(range.start)}
        onDateValidate={props.onDateValidate}
        showTimeInput={showTimeInput}
        disablePastDates={disablePastDates}
        valid={valid}
      />
    </div>
  )
}

export interface DateRangePickerProps extends Props<DateRange> {
  blockedRangeSections?: RangePoint[]
  hideRangeSection?: RangePoint
  onOpenChange?: (isOpen: boolean) => void
}

export const DateRangePicker = (props: DateRangePickerProps) => {
  const {
    value,
    onChange,
    onOpenChange,
    showTimeInput,
    hideRangeSection,
    blockedRangeSections
  } = props
  const points = ['start', 'end'] as const
  const disableSetDeadlineBeforeStart = blockedRangeSections?.includes('start')

  return (
    <div className={wrapperClassName}>
      {points.map(
        point =>
          hideRangeSection !== point && (
            <PickerSection
              key={point}
              dateRange={value}
              rangePoint={point}
              onChange={onChange}
              onOpenChange={onOpenChange}
              showTimeInput={showTimeInput}
              showLabel={!hideRangeSection}
              blocked={blockedRangeSections?.includes(point)}
              disableSetDeadlineBeforeStart={disableSetDeadlineBeforeStart}
            />
          )
      )}
    </div>
  )
}

const wrapperClassName = 'p-8 bg-main-old inline-flex'
